/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ date: NonNullable<unknown> }} Menuupdatedat2Inputs */

const en_menuupdatedat2 = /** @type {(inputs: Menuupdatedat2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Last changed: ${i?.date}`)
};

const de_menuupdatedat2 = /** @type {(inputs: Menuupdatedat2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Zuletzt geändert: ${i?.date}`)
};

/**
* | output |
* | --- |
* | "Last changed: {date}" |
*
* @param {Menuupdatedat2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const menuupdatedat2 = /** @type {((inputs: Menuupdatedat2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Menuupdatedat2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_menuupdatedat2(inputs)
	return de_menuupdatedat2(inputs)
});
export { menuupdatedat2 as "menuUpdatedAt" }